import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

/**
 * 実力テスト教科別成績取得（志望校判断）
 */
export namespace ApiTaRe240 {
  // API Name
  export const name: string = 'ApiTaRe240'

  // GET parameters
  export namespace Get {
    export const path: string = '/ta/testSchoolJudgmentSubjects'

    export interface Request {
      query: {
        subjectCode: string
        fiscalYear: number
        grade: number
        testMonth: number
        testCount?: number
        courseId: string
      }
    }

    export interface Response {
      placementTestReportSubject: {
        partNumber: string
        questionNumber: string
        difficulity: string
        allocation: string
        score: string
        average: string
      }[]
    }
  }

  // API本体
  export class Api extends ApiBase implements Gettable<Get.Request, Get.Response, ResponseError> {
    // GET
    public get<R>(
      params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造サンプル
      const validationSample: Get.Response = {
        placementTestReportSubject: [
          {
            partNumber: '',
            questionNumber: '',
            difficulity: '',
            allocation: '',
            score: '',
            average: '',
          },
        ],
      }

      // エラー時のレスポンス構造サンプル
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      // API呼び出し
      return this.callbackWrapper<Get.Response, ResponseError, R>(
        api.get<Get.Response>(Get.path, { params: params.query }),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
